'use client';
import { jsx as _jsx } from "react/jsx-runtime";
// A control label that can be user content (a group name): cut with "…"
// inside its width-capped control, with the full text in a tooltip. The
// tooltip only opens when the label really is cut off — checked at the
// moment it would open, so a label that fits never shows a redundant one.
// Touch devices get no tooltip (see Tooltip); the full text stays in the DOM
// for assistive tech, and overflow menus list labels in full.
import { useRef, useState } from 'react';
import { TextTrim } from '../../system/text-trim';
import { Tooltip } from '../Tooltip/Tooltip';
function isCutOff(label) {
    return label !== null && label.scrollWidth > label.clientWidth;
}
export function TruncatedLabel({ children }) {
    const label = useRef(null);
    const [open, setOpen] = useState(false);
    return (_jsx(Tooltip, { content: children, open: open, onOpenChange: (next) => setOpen(next && isCutOff(label.current)), children: _jsx(TextTrim, { ref: label, truncate: true, children: children }) }));
}
//# sourceMappingURL=TruncatedLabel.js.map